import AdvancedInput, { Transformation } from "@edaz/edazkit/controls/AdvancedInput";
import AdvancedSelect from "@edaz/edazkit/controls/AdvancedSelect";
import { Input } from "@frui.ts/bootstrap";
import type { ViewComponent } from "@frui.ts/views";
import FormGroup from "controls/formGroup";
import FormLabel from "controls/formLabel";
import LicensePlateInput from "controls/licensePlateInput";
import { observer } from "mobx-react-lite";
import React from "react";
import { Col, Form } from "react-bootstrap";
import type RejectedCustomerRefundCandidatesViewModel from "viewModels/finance/customerRefunds/rejectedCustomerRefundCandidates/rejectedCustomerRefundCandidatesViewModel";
import CountrySelect from "views/common/countrySelect";
import FilterView from "views/common/filter";

const RejectedCustomerRefundCandidatesFilter: ViewComponent<RejectedCustomerRefundCandidatesViewModel> = observer(({ vm }) => {
  const fullTextClassNames = vm.filter.fullTextSearchEnabled ? "border-success border-2" : "";

  return (
    <FilterView vm={vm}>
      <Form.Row>
        <FormGroup as={Col} sm={6} md={4} lg={3} target={vm.filter} property="countryId">
          <FormLabel>{vm.translateFilterAttribute("countryId")}</FormLabel>
          <CountrySelect vm={vm.countrySelectViewModel} />
        </FormGroup>
        <FormGroup as={Col} sm={6} md={4} lg={3} target={vm.filter} property="licensePlate">
          <FormLabel>{vm.translateFilterAttribute("licensePlate")}</FormLabel>
          <LicensePlateInput className={fullTextClassNames} />
        </FormGroup>
        <FormGroup as={Col} sm={6} md={4} lg={3} target={vm.filter} property="officialRecordId">
          <FormLabel>{vm.translateFilterAttribute("officialRecordId")}</FormLabel>
          <AdvancedInput transformation={Transformation.UpperCased} className={fullTextClassNames} />
        </FormGroup>
        <FormGroup as={Col} sm={6} md={4} lg={3} target={vm.filter} property="variableSymbol">
          <FormLabel>{vm.translateFilterAttribute("variableSymbol")}</FormLabel>
          <Input />
        </FormGroup>
        <FormGroup as={Col} sm={6} md={4} lg={3} target={vm.filter} property="status">
          <FormLabel>{vm.translateFilterAttribute("status")}</FormLabel>
          <AdvancedSelect items={vm.statusOptions} />
        </FormGroup>
      </Form.Row>
    </FilterView>
  );
});

export default RejectedCustomerRefundCandidatesFilter;
